












import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class UiLabel extends Vue {
  closedBlocks:string[] = [];
  
  @Prop()
  html: string;
  
  @Prop({default:'w100'})
  width: string;
  
  @Prop()
  name: string;
  
  @Prop()
  close: Boolean;
  
  @Prop()
  closeHandle: Function;
  
  created(){
    this.getClosedBlocks()
  }

  getClosedBlocks(){
    const value = window.localStorage.getItem('infoBlocksClosed');
    this.closedBlocks =  value && JSON.parse(value) || [];
  }

  closeClick(){
    // save close state in special way, e.x. on backend side 
    if(this.closeHandle) return this.closeHandle();

    // save close state on localStorage  
    window.localStorage.setItem(
      'infoBlocksClosed',
      JSON.stringify([...new Set([
        ...this.closedBlocks,
        this.name
      ])]));
    
    this.getClosedBlocks();
  }

  @Prop({default: 'green'})
  color: string;
  
  get iconColor(){
    switch (this.color){
      case 'green': return this.$colors.graphite;
      case 'red': return this.$colors.red;
      default: return this.$colors.graphite;
    }
  }
}
